var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// tslint:disable:function-name
var sparqlTokenMap = require('../sparql/tokens').sparqlTokenMap;
var _a = require('./tokens'), srsTokenMap = _a.srsTokenMap, srsTokenTypes = _a.srsTokenTypes, multiModeLexerDefinition = _a.multiModeLexerDefinition;
import { Parser, Lexer, } from 'chevrotain';
import { TurtleParser } from '../turtle/TurtleParser';
import { isCstNode, unsafeTraverse } from '../helpers/chevrotain/cst';
import { defaultNamespacesMap } from 'turtle/defaultNamespaces';
import { getSparqlSrsVisitor, reduceVisitorItemErrors, findAndSwapPlaceholders, } from './visitor';
import { addThenClauseErrorsToErrors, addIfClauseErrorsToErrors, } from './customErrors';
var SrsParser = /** @class */ (function (_super) {
    __extends(SrsParser, _super);
    function SrsParser(config) {
        var _this = _super.call(this, __assign({ outputCst: true, recoveryEnabled: true }, config), srsTokenTypes, multiModeLexerDefinition, false) || this;
        _this.baseNamespacesMap = Object.freeze(__assign({}, defaultNamespacesMap));
        _this.namespacesMap = {};
        _this.visitCst = function (cst) {
            // To save resources while parsing, the sparqlSrsVisitor is a singleton.
            if (!_this.sparqlSrsVisitor) {
                var BaseSrsVisitor = _this.getBaseCstVisitorConstructorWithDefaults();
                _this.sparqlSrsVisitor = getSparqlSrsVisitor(BaseSrsVisitor);
            }
            else {
                _this.sparqlSrsVisitor.$resetState();
            }
            _this.sparqlSrsVisitor.visit(cst, _this.input);
        };
        _this.getSparqlRulesFromVisitor = function (cst) {
            _this.visitCst(cst);
            return {
                groupGraphPatterns: _this.sparqlSrsVisitor.$getGroupGraphPatterns(),
                triplesBlocks: _this.sparqlSrsVisitor.$getTriplesBlocks(),
            };
        };
        _this.resetManagedState = function () {
            _this.namespacesMap = __assign({}, defaultNamespacesMap);
            _this.semanticErrors = [];
        };
        _this.setBaseNamespaces = function (newBaseNamespaces) {
            _this.baseNamespacesMap = __assign({}, newBaseNamespaces);
        };
        _this.tokenize = function (document) {
            return _this.lexer.tokenize(document).tokens;
        };
        _this.parse = function (document, mode) {
            if (mode === void 0) { mode = 'standard'; }
            _this.resetManagedState();
            _this.input = _this.lexer.tokenize(document).tokens;
            var cst = _this.SrsDoc(0, [mode]);
            var _a = _this.getSparqlRulesFromVisitor(cst), groupGraphPatterns = _a.groupGraphPatterns, triplesBlocks = _a.triplesBlocks;
            // Pull visitor errors
            var errors = _this.errors.concat(groupGraphPatterns.reduce(reduceVisitorItemErrors, []), triplesBlocks.reduce(reduceVisitorItemErrors, []));
            var semanticErrors = _this.semanticErrors.slice();
            // Replace placeholder CST nodes created by the SRS parser with CST nodes
            // returned by the visitor sub-parsers.
            unsafeTraverse(cst, function (ctx, next) {
                var node = ctx.node, parentCtx = ctx.parentCtx;
                if (isCstNode(node)) {
                    return next();
                }
                var currentTokenName = node.tokenType.tokenName;
                if (currentTokenName !== 'GroupGraphPattern' &&
                    currentTokenName !== 'TriplesBlock') {
                    return;
                }
                var parentNode = parentCtx.node;
                // The SRS parser parses only Turtle and SRS-specific content (RULE, IF,
                // THEN), and creates placeholder tokens for the blocks where SPARQL is
                // valid. The SparqlSrsVisitor visits these nodes and delegates their
                // parsing to a SPARQL parser. Here, we replace the placeholder nodes
                // (`GroupGraphPattern` and `TriplesBlock`) with the real ones from the
                // SPARQL parser, collecting some custom SRS-specific errors along the
                // way.
                if (parentNode.name === 'IfClause') {
                    var matchingVisitorItem = findAndSwapPlaceholders(node, parentNode, groupGraphPatterns, 'GroupGraphPattern');
                    if (matchingVisitorItem) {
                        addIfClauseErrorsToErrors({
                            fullCtx: ctx,
                            namespacesMap: __assign({}, _this.baseNamespacesMap, _this.namespacesMap),
                            cst: matchingVisitorItem.parseResult.cst,
                            errors: errors,
                            semanticErrors: semanticErrors,
                        });
                    }
                }
                else if (parentNode.name === 'ThenClause') {
                    var matchingVisitorItem = findAndSwapPlaceholders(node, parentNode, triplesBlocks, 'TriplesBlock');
                    if (matchingVisitorItem) {
                        addThenClauseErrorsToErrors({
                            fullCtx: ctx,
                            namespacesMap: __assign({}, _this.baseNamespacesMap, _this.namespacesMap),
                            cst: matchingVisitorItem.parseResult.cst,
                            errors: errors,
                            semanticErrors: semanticErrors,
                        });
                    }
                }
            });
            return {
                semanticErrors: semanticErrors,
                errors: errors,
                cst: cst,
            };
        };
        _this.SrsDoc = _this.RULE('SrsDoc', function (mode) {
            var allowEdgeProperties = mode === 'stardog';
            _this.SUBRULE(_this.turtleDoc, { ARGS: [mode] });
            _this.MANY(function () {
                _this.SUBRULE(_this.RuleDoc);
                _this.MANY1(function () {
                    _this.SUBRULE(_this.triples, { ARGS: [allowEdgeProperties] });
                    _this.CONSUME(sparqlTokenMap.Period);
                });
            });
        });
        _this.RuleDoc = _this.RULE('RuleDoc', function () {
            _this.OPTION(function () { return _this.SUBRULE(_this.RuleClause); });
            _this.SUBRULE(_this.IfClause);
            _this.SUBRULE(_this.ThenClause);
        });
        _this.RuleClause = _this.RULE('RuleClause', function () {
            _this.CONSUME(srsTokenMap.Rule);
            _this.SUBRULE(_this.iri);
        });
        _this.IfClause = _this.RULE('IfClause', function () {
            _this.CONSUME(srsTokenMap.If);
            _this.CONSUME(srsTokenMap.GroupGraphPattern);
        });
        _this.ThenClause = _this.RULE('ThenClause', function () {
            _this.CONSUME(srsTokenMap.Then);
            _this.CONSUME(sparqlTokenMap.LCurly);
            _this.CONSUME(srsTokenMap.TriplesBlock);
            _this.CONSUME(srsTokenMap.EndThen);
        });
        _this.lexer = new Lexer(multiModeLexerDefinition);
        Parser.performSelfAnalysis(_this);
        return _this;
    }
    return SrsParser;
}(TurtleParser));
export { SrsParser };
